import React, { useState, useEffect } from "react";
import "./ViewSubject.scss";
import Button from "../../controls/buttons/Button";
import arrowLeft from '../../../assets/arrowLeft.png';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import ModuleItem from "../ModuleItem/ModuleItem";
import placeholder from '../../../assets/Subject-cover-placeholder.png';
import ClearIcon from '@material-ui/icons/Clear';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import ViewClasse from "../ViewClasse/ViewClasse";




function ViewSubject({ communityList, changeScreen, subject }) {

    const [eventId, setEventId] = useState(undefined);
    const [showLoading, setShowLoading] = useState(false);
    const [subjectName, setSubjectName] = useState('');
    const [subjectCover, setSubjectCover] = useState('');
    const [subjectDesc, setSubjectDesc] = useState('');
    const [subjectTags, setSubjectTags] = useState([]);
    const [subjectGroup, setSubjectGroup] = useState([]);
    const [subjectModules, setSubjectModules] = useState([]);
    const [subjectClasses, setSubjectClasses] = useState([]);
    const [moduleIndex, setModuleIndex] = useState(null);
    const [classIndex, setClassIndex] = useState(null);
    const [totalClasses, setTotalClasses] = useState([]);
    const [tempTags, setTempTags] = useState('');
    const [tempGroup, setTempGroup] = useState(null);
    const [preview, setPreview] = useState()
    const [viewAula, setViewAula] = useState(false);


    useEffect(() => {
        if (subject) {
            setSubjectName(subject.name ? subject.name : '');
            setSubjectCover(subject.cover ? subject.cover : '')
            setSubjectDesc(subject.description ? subject.description : '')
            setSubjectTags(subject.tags ? subject.tags : [])
            setSubjectGroup(subject.groupsInfo ? subject.groupsInfo : [])
            setSubjectClasses(subject.subjectClasses ? subject.subjectClasses : [])
            let modules = [];
            let count = 0;
            if (subject.subjectModules) {
                subject.subjectModules.forEach(el => {
                    if (!el.draft) {
                        modules.push(el);
                    }
                    el.classList.forEach(cl => {
                        if (!cl.draft) {
                            count = count + 1;
                        }

                    });
                });
                setSubjectModules(modules);
            }
            let aulas = [];
            if (subject.subjectClasses) {
                subject.subjectClasses.forEach(el => {
                    if (!el.draft) {
                        aulas.push(el);
                        count = count + 1;
                    }
                });
                setSubjectClasses(aulas);
            }
            setTotalClasses(count)
        }


    }, []);



    function renderTags() {
        let array = subjectTags;
        let tags = [];
        array.forEach(el => {
            tags.push(
                <Grid item>
                    <Chip label={el} color="primary" />
                </Grid>
            )
        });
        return tags;
    }


    function renderGroups() {
        let array = subjectGroup;
        let tags = [];
        array.forEach(el => {
            tags.push(
                <Grid item>
                    <Chip label={el.title} color="primary" />
                </Grid>
            )
        });
        return tags;
    }




    function viewClass(indexM, indexC) {
        setModuleIndex(indexM);
        setClassIndex(indexC);
        setViewAula(true);
    }

    function renderModules() {
        let array = [...subjectModules];
        let modules = []
        array.forEach((el, index) => {
            modules.push(
                <Grid item>
                    <ModuleItem module={el} admin={false}
                        modIndex={index}
                        viewClass={viewClass} />
                </Grid>
            )
        });
        return modules;
    }



    useEffect(() => {
        if (!subjectCover) {
            setPreview(undefined)
            return
        }
        if (subjectCover && subjectCover.photo) {
            setPreview(subjectCover.photo)
            return
        }


    }, [subjectCover])

    function getClassDate() {
        let d = new Date(subjectModules[moduleIndex].classList[classIndex].classDate)
        return (d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear())
    }



    return (
        <>
            {!viewAula &&
                <Grid container>
                    <Grid item xs={12}>
                        <div className="view-subjects-main">
                            {showLoading && <div class="loader" />}
                            <div className="view-title-subjects">
                                <span >Disciplinas</span>
                            </div>

                            <div className="view-subjects-header">
                                <img src={arrowLeft} style={{ height: '18px' }}></img>
                                <span className="subtitle-view-subjects" onClick={(e) => changeScreen(e, 'main')}>Disciplina |</span>
                                <div className="Subject-name-field">
                                    <label
                                        className="Subject-name-view"
                                    >
                                        {subjectName}
                                    </label>
                                </div>
                            </div>

                            <div className="view-subjects-image">
                                <img className={'cover'} src={preview ? preview : placeholder} ></img>

                            </div>
                            <div className="Subject-description-view">
                                <label
                                    className="Subject-description-view"
                                >
                                    {subjectDesc}
                                </label>
                            </div>
                            <div className="view-subjects-tag-label">
                                <label > Para os Grupos</label>
                            </div>
                            {subjectGroup.length > 0 && <div className="view-subjects-tags">
                                <Grid container direction="row" justifyContent="flex-start" spacing={1}>
                                    {renderGroups()}
                                </Grid>

                            </div>}
                            <div className="view-subjects-tag-label">
                                <label > Tags</label>
                            </div>
                            {subjectTags.length > 0 && <div className="view-subjects-tags">
                                <Grid container direction="row" justifyContent="flex-start" spacing={1}>
                                    {renderTags()}
                                </Grid>

                            </div>}

                            <div className="view-subjects-modules-div">
                                <div className="view-subjects-modules-label">
                                    <label >Módulos <span className="gray">({subjectModules.length})</span> e Aulas <span className="gray">({totalClasses})</span></label>
                                </div>
                            </div>

                            {
                                subjectModules.length > 0 && renderModules()
                            }

                            <div className="view-subjects-footer-div">
                                <div className="view-subjects-modules-btn">
                                    <label onClick={(e) => changeScreen(e, 'main')}>
                                        <Button Outline>
                                            <span>Voltar</span>
                                        </Button>
                                    </label>
                                </div>

                            </div>

                        </div>
                    </Grid>
                </Grid>

            }
            {viewAula && <ViewClasse goBack={() => setViewAula(false)} aula={subjectModules[moduleIndex].classList[classIndex]} index={classIndex + 1} modName={subjectModules[moduleIndex].name} />}

        </>


    );
}

export default ViewSubject;
